module.exports = __webpack_public_path__ + "static/media/Racial_Diversity_App_recording.b7c244dd.mp4";